import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { env } from "../../env/env";
import toast, { Toaster } from "react-hot-toast";
import { useForm } from "react-hook-form";
const API_ENDPOINT = `${ env.API_ENDPOINT }`;

const EstadoTramite = () => {



    const tramite = useRef();

    const getubicacion = async () => {
        await axios
            .get( `${ API_ENDPOINT }/obtenerubicacionweb?tramite=${ tramite.current.value }` )
            .then( async function ( response ) {
                if ( response.data.length === 0 ) {
                    toast.success( "Ubicación no disponible" );
                } else {
                    if ( response.data[ 0 ].ubicacion.trim() === "ENTREGADO AL USUARIO (PRESENCIAL)" ) {
                        toast.success( "ENTREGADO AL USUARIO" );
                    } else if ( response.data[ 0 ].ubicacion.trim() === "ENTREGADO AL USUARIO (EMAIL)" ) {
                        toast.success( "ENTREGADO AL USUARIO" );
                    } else if ( response.data[ 0 ].ubicacion.trim() === "RECIBIDA EN GESTIÓN DE OBSERVACIONES" ) {
                        toast.success( "EN MÓDULO DE OBSERVACIONES" );
                    }
                    else if ( response.data[ 0 ].ubicacion.trim() === "RECIBIDO ENTREGA DE DOCUMENTOS" ) {
                        toast.success( "EN MÓDULO DE ENTREGA DE DOCUMENTOS" );
                    } else {
                        toast.success( "EN PROCESO" );
                    }
                }
            } )
            .catch( function ( error ) {
                // handle error
                console.log( error );
                toast.error( "Mensaje del sistema", "Error!" );
            } );
    };

    return (
        <>
            <Toaster />
            <section className="content">

                <div className="card border-left-danger shadow  py-2">
                    {/* Card Header - Dropdown */ }
                    <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 className="m-0 font-weight-bold text-danger">Ingrese Número de trámite:</h6>
                    </div>
                    {/* Card Body */ }
                    <div className="card-body">
                        <div className="user">
                            <div className="form-group row">
                                <div className="col-sm-3 mb-3 mb-sm-0">
                                    <label className="text-danger">Nro. Trámite:</label>
                                    <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ tramite } />
                                </div>
                                <div className="col-sm-1 mb-3 mb-sm-0">
                                    <label style={ { color: 'white' } }>Buscar:</label>
                                    <button className="btn btn-danger" style={ { width: '100%' } } onClick={ getubicacion }><i class="fas fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
};

export default EstadoTramite;
